import { atom } from "recoil";

export const enableExternalsState = atom<boolean>({
  key: "enableExternalsState",
  default: false,
});
